import { Document } from '@contentful/rich-text-types';

export enum Tab {
  CreditCard = 'CREDIT_CARD',
  ACH = 'ACH',
  MailInCheck = 'MAIL_IN_CHECK',
}

export interface AgreementData {
  main: Document;
  emailConfirmation?: Document;
  mainSecondaryAction: string;
  mainPrimaryAction?: string;
}

export interface AgreementsMap {
  [key: string]: AgreementData;
}
